import { render, staticRenderFns } from "./TableController.vue?vue&type=template&id=d4018254&"
import script from "./TableController.vue?vue&type=script&lang=js&"
export * from "./TableController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports